<template>
  <span :class="['ui-icon', plain ? 'ui-icon-plain' : `ui-icon-${color}`, `ui-icon-${size}`]">
    <i :class="iconClass"></i>
  </span>
</template>

<script>
const MAP = {
  camera: 'el-icon-camera',
  list: 'el-icon-document',
  family: 'el-icon-s-custom',
  setting: 'el-icon-setting',
  user: 'el-icon-user',
  edit: 'el-icon-edit-outline',
  wallet: 'el-icon-wallet',
  sport: 'el-icon-trophy',
  check: 'el-icon-circle-check',
  book: 'el-icon-reading',
  clock: 'el-icon-time',
  ball: 'el-icon-football',
  arrow: 'el-icon-arrow-right',
  home: 'el-icon-s-home'
}

export default {
  name: 'UiIcon',
  props: {
    name: { type: String, required: true },
    size: { type: String, default: 'md' },
    color: { type: String, default: 'blue' },
    plain: { type: Boolean, default: false }
  },
  computed: {
    iconClass() {
      return MAP[this.name] || 'el-icon-menu'
    }
  }
}
</script>

<style scoped>
.ui-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  flex-shrink: 0;
}
.ui-icon-sm { width: 36px; height: 36px; font-size: 18px; border-radius: 10px; }
.ui-icon-md { width: 48px; height: 48px; font-size: 22px; }
.ui-icon-lg { width: 56px; height: 56px; font-size: 26px; }
.ui-icon-blue { background: #EEF2FF; color: #6366F1; }
.ui-icon-green { background: #ECFDF5; color: #10B981; }
.ui-icon-amber { background: #FFFBEB; color: #F59E0B; }
.ui-icon-purple { background: #F3E8FF; color: #8B5CF6; }
.ui-icon-white { background: rgba(255,255,255,0.25); color: #fff; }
.ui-icon-plain { background: transparent; color: #CBD5E1; }
</style>
